import { Component, Input, OnInit } from '@angular/core';
import { SchoolFinancialsComponent } from '../school-financials/school-financials.component';
import { FinancialDashboardGroup } from '../../models/financial-dashboard-config.model';


@Component({
  selector: 'app-school-pass-rates',
  template: `
    <div (click)="navToReports()">
        <app-financial-dashboard *ngIf="financialDashboardConfig" [financialDashboardConfig]="financialDashboardConfig"
       [customFilters]="customFilters"
       [hidePageContent]="hidePageContent"
       [hidePills]="hidePills"
       [hideFilters]="hideFilters"
       [hideChartDisplayPreferenceToggle]="true"
       
       (currentGroupChanged)="setGroup($event)"></app-financial-dashboard>
    </div>
  `
})
export class SchoolPassRatesComponent extends SchoolFinancialsComponent {
  @Input() pilotExaminerId: number;
  @Input() flightSchoolBranchId: number;
  @Input() FlightSchoolInstructorId: number;

  @Input() hidePageContent: boolean = true;
  @Input() hidePills: boolean = true;
  @Input() hideFilters: boolean = true;

  @Input() contentConfigKey: string = 'school-pass-rates';

  ngOnInit(): void {
    super.ngOnInit();

  }

  navToReports() {
    this.dwRoutingService.navigateToUrl('/school-reports/pass-rates');
  }

  setupDashboard() {
    const pilexosUser = this.adminManagerService.getPilexosUser();

    this.lookupParams.push(pilexosUser.flightSchoolOrganizationId);

    this.financialDashboardConfig = {
      contentConfigKey: this.contentConfigKey,
      staticFilter: {
        flightSchoolOrganizationId: pilexosUser?.flightSchoolOrganizationId || -1,
        //pilotExaminerId: this.examiner?.PilotExaminerId || -1,
      },
      groups: [
        this.buildCheckrideGroup()
      ]
    }
  }

  buildCheckrideGroup(): FinancialDashboardGroup {
    const group = super.buildCheckrideGroup();

    group.charts = [];

    return group;
  }

}
